import React, { useEffect, useMemo, useState } from "react";
import NodeNameValidation from "../../atoms/node-name-validation";
import { Card, Col, FormGroup, Input, Label, Row } from "reactstrap";
import HelpTooltip from "../../atoms/help-tooltip";
import InputData from "../../atoms/input-data";
import { FUNCTION_TYPES } from "../../../utils/nodeTypes";
import { cloneDeep } from "lodash";
import useCustomReducer from "../../../hooks/useCustomReducer";
import DynamicInputs from "../../atoms/dynamic-inputs";
import { t } from "../../../utils/utils";
import T from "../../atoms/translate";
export default function NodeFunctionProperty({
  node,
  nodeChange,
  dependencies
}) {
  const [form, setForm] = useCustomReducer({});
  const [fromContext, setFromContext] = useState("");
  const [inputData, setInputData] = useState({});
  const [funcType, setFuncType] = useState("");
  const [validation, setValidation] = useState(null);
  const [basicValidation, setBasicValidation] = useState({});
  const func_types = useMemo(() => {
    if (inputData) {
      const firstKey = Object.keys(inputData)[0];
      if (firstKey && inputData[firstKey].type) {
        return FUNCTION_TYPES.filter(o =>
          o.use.includes(inputData[firstKey].type.toLowerCase())
        );
      }
    }
    return [];
  }, [inputData]);

  useEffect(() => {
    const tmp = {};
    if (!fromContext) {
      tmp.fromContext = "danger";
    } else tmp.fromContext = "success";
    if (!funcType) {
      tmp.funcType = "danger";
    } else tmp.funcType = "success";
    setBasicValidation(tmp);
  }, [funcType, fromContext]);
  const other_inputs = useMemo(() => {
    if (funcType) {
      const data = FUNCTION_TYPES.find(o => o.type === funcType);
      if (data) {
        const tmp = data.form
          ? Object.entries(data.form).map(([key, o]) => ({ name: key, ...o }))
          : [];
        setForm(() => ({}));
        if (tmp.length > 0) {
          const { args } = node.properties;
          console.log(args.options);
          const newForm = Object.fromEntries(
            tmp.map(o => [
              o.name,
              args.options && args.options[o.name] ? args.options[o.name] : ""
            ])
          );
          setForm(newForm);
        }

        return tmp;
      }
    }
    return [];
  }, [funcType, setForm, node]);
  useEffect(() => {
    const { args } = node.properties;
    if (args) {
      setInputData(args.inputData ? args.inputData : {});
      //args.operatorFunction (structure):{
      // type:"", --> tipo de funcion que se ocupara
      // to:"" ---> sobre varible se realizara la operacion
      // }
      if (args.operatorFunction) {
        setFuncType(args.operatorFunction.type);
        setFromContext(args.operatorFunction.to);
      }
    }
  }, [node, setForm]);
  const changeInputData = data => {
    setInputData(data.inputData);
    setFromContext(data.data);
  };
  const changeFucType = ({ target }) => {
    const values = [].filter
      .call(target.options, o => o.selected)
      .map(o => o.value);
    setFuncType(values[0]);
  };
  const onSubmit = name => {
    const tmp = cloneDeep(node);
    tmp.properties.name = name;
    if (
      !Object.entries(validation).find(([key, o]) => o === "danger") &&
      !Object.entries(basicValidation).find(([key, o]) => o === "danger")
    ) {
      if (inputData) {
        // TODO: missing validation
        tmp.properties.args = {
          inputData: inputData,
          operatorFunction: funcType
            ? {
                type: funcType,
                to: fromContext
              }
            : {},
          // se guarda los datos dinamicos dentro de los option (key : value ) segun los datos configurados en nodeTypes->FUNCTION_TYPES
          options:
            Object.keys(form).length > 0
              ? Object.fromEntries(
                  other_inputs.map(o => [o.name, form[o.name]])
                )
              : null
        };
      }
      nodeChange(tmp);
    }
  };
  return (
    <>
      <NodeNameValidation
        label={t("modalPropiedadesLabelNodoValidacionNombre")}
        feedback={t("modalPropiedadesFeedbackValidacionNombre")}
        nodesNames={dependencies.nodeNames}
        oldName={node.properties.name}
        onSubmit={onSubmit}
      />
      <Row>
        <Col md={12}>
          <Card body className="border-0 box-shadow mb-4">
            <Row>
              <Col xs="12">
                <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
                  <T i18nKey="modalPropiedadesFuncionTitulo" />
                </h1>
              </Col>
              <Col xs="12">
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <Label>
                        <T i18nKey="valor" />{" "}
                        <HelpTooltip
                          msg={t("modalPropiedadesFuncionValorTooltip")}
                        />
                      </Label>
                      <InputData
                        context={dependencies.context}
                        changeInput={changeInputData}
                      >
                        <Input
                          type="text"
                          disabled={true}
                          invalid={basicValidation.fromContext === "danger"}
                          value={fromContext}
                          onChange={e => setFromContext(e.target.value)}
                        />
                      </InputData>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label>
                        <T i18nKey="modalPropiedadesFuncionOperacionesDisponibles" />{" "}
                        <HelpTooltip
                          msg={
                            <p className="mb-0">
                              <T i18nKey="modalPropiedadesFuncionOperacionesTooltip" />
                            </p>
                          }
                        />
                      </Label>
                      <Input
                        type="select"
                        onChange={changeFucType}
                        invalid={basicValidation.funcType === "danger"}
                        value={funcType}
                      >
                        <option value="" />
                        {func_types.map((o, key) => (
                          <option key={key} value={o.type}>
                            {o.name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
          {funcType ? (
            <DynamicInputs
              form={form}
              inputs={other_inputs}
              setForm={setForm}
              setValidation={setValidation}
              validation={validation}
            />
          ) : null}
        </Col>
      </Row>
    </>
  );
}
